<template>
  <section class="footer">
    <div
      id="o-footer-syndication"
      class="footer-title">
      <div>
        <footer-title />
      </div>
    </div>
    <h2 class="sr-only">
      {{ footerConfig.srOnly }}
    </h2>
    <div class="footer-content">
      <div class="links-section">
        <links-section :links-section="footerConfig.linksSection" />
        <div class="info-tv-section">
          {{ footerConfig.infoTvSection }}
        </div>
      </div>
      <div class="apps-section">
        <div class="lvo-section">
          <lvo-section
            :lvo-section="footerConfig.lvoSection"
            :used-o-s="usedOS" />
        </div>
        <div class="appstores-section">
          <div class="info-tv-section">
            {{ footerConfig.infoTvSection }}
          </div>
          <mobile-app-section :config="footerConfig.appSection" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import footerConfig from './Footer.config'
import FooterTitle from './title/FooterTitle'
import LvoSection from './lvo/LvoSection'
import MobileAppSection from './mobileAppSection/MobileAppSection'
import LinksSection from './links/LinksSection'
export default {
  name: 'WptvFooter',
  components: {
    LinksSection,
    FooterTitle,
    LvoSection,
    MobileAppSection
  },
  props: {
    usedOS: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      footerConfig
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/variables';
@import '../../scss/abstracts/mixins';

.footer {
  margin-top: 25px;
  background: $black;
  color: $white;

  .footer-title#o-footer-syndication {
    width: 100%;
    height: 147px;
    background: $darkgrey;
    @include mediaQueries('height', (small: 81px));

    > div {
      @include mediaQueries('padding', (xxsmall: 0 20px, medium: 0 27px, large: 0 55px, xlarge: 0 60px));
      max-width: 1440px;
      margin: auto;
    }
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    @include mediaQueries('flex-direction', (large: row));
    max-width: 1440px;
    margin: 35px 0 0;
    @include mediaQueries('margin', (xlarge: 35px auto 0));
    @include mediaQueries('padding', (xxsmall: 0 20px, medium: 0 27px 35px, large: 0 55px 35px, xlarge: 0 60px 35px));

    .links-section {
      flex: 2;

      .info-tv-section {
        display: none;
        @include mediaQueries('display', (large: 'block'));
        padding-top: 15px;
      }
    }

    .info-tv-section {
      width: 100%;
      font-weight: 700;
      font-size: 16px;
      @include mediaQueries('font-size', (large: 18px));
      padding: 15px 30px 0 0;
    }

    .apps-section {
      display: flex;
      flex: 1;
      flex-direction: column;
      @include mediaQueries('flex-direction', (medium: 'row', large: 'column'));

      .lvo-section {
        display: none;
        @include mediaQueries('display', (medium: 'initial'));
        @include mediaQueries('flex', (medium: 1));
      }

      .appstores-section {
        @include mediaQueries('flex', (medium: 1));
        @include mediaQueries('margin-top', (large: 30px));

        .info-tv-section {
          @include mediaQueries('display', (large: 'none'));
          margin-bottom: 30px;
        }
      }
    }

  }
}
</style>
